import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5111ab9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-btn" }, " 添加 ", -1))

import {ref} from "vue";
import { Uploader, Toast } from "vant";
import { uploadFile } from "@/utils/tools"
interface IProps {
    maxCount?: number;
    multiple?: boolean;
    disabled?: boolean;
    readonly?:boolean;
    format?: string[];
    accept?: string;
    maxSize?: number;
    sizeError?: string;
    originalName?: boolean;
    func?: (list:Array<unknown>)=>void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    maxCount: { default: 9 },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    format: { default: () => [] },
    accept: { default: "image/*" },
    maxSize: { default: 0 },
    sizeError: { default: "文件大小超出限制" },
    originalName: { type: Boolean, default: false },
    func: { type: Function, default: null }
  },
  emits: ["success"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { maxCount: number, multiple: boolean, disabled: boolean, readonly:boolean, format: string[], accept: string, maxSize: number, sizeError: string, originalName: boolean, func: (list:Array<unknown>)=>void }

const uploaderRef = ref();


const onAfterRead = (res) => {
    let files = generateFiles(res);

    if (!checkFormat(files)) {
        if (!props.multiple) {
            return false;
        } else {
            //多选上传复合格式的文件
            files = files.filter(info => {
                return props.format.includes(info.ext);
            });
        }
    }
    if (!checkSize(files)) return;
    if (props.func) {
        props.func(files);
    } else {
        doUpload(files);
    }
}
const generateFiles = (data) => {
    const fileInfos = [];
    if (data.length) {
        for (const file of data) {
            fileInfos.push({
                ext: file.file.name.split(".").pop() || "",
                file: file.file,
            });
        }
    } else {
        fileInfos.push({
            ext: data.file.name.split(".").pop() || "",
            file: data.file,
        });
    }
    return fileInfos;
}
const checkFormat = (fileInfos) => {
    if (!props.format.length) return true;
    for (const info of fileInfos) {
        if (!props.format.includes(info.ext.toLowerCase())) {
            toast("不支持文件格式：" + info.ext);
            return false;
        }
    }
    return true;
}
const checkSize = (fileInfos) => {
    if (props.maxSize <= 0) return true;
    for (const info of fileInfos) {
        const size = info.file.size / 1024;
        if (size > props.maxSize) {
            toast(props.sizeError)
            return false;
        }
    }
    return true;
}
const doUpload = async (fileInfos) => {
    const uploads = fileInfos.map(fileInfo =>
        uploadFile(
            fileInfo.file,
            fileInfo.ext,
            props.originalName,
        ),
    );
    let result;
    try {
        result = await Promise.all(uploads);
    } catch (e) {
        toast("上传失败，请前往管理后台重试");
        console.error("OSS上传失败，错误消息:" + e);
    }
    if (result && result.length) {
        result.forEach(i => {
            emits("success", i);
        });
    }
}
const toast = (msg: string) => {
    Toast(msg);
}
const chooseFile = ()=>{
    uploaderRef.value.chooseFile();
}
expose({chooseFile});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Uploader), {
    ref_key: "uploaderRef",
    ref: uploaderRef,
    "max-count": props.maxCount,
    disabled: props.disabled,
    readonly: props.readonly,
    multiple: props.multiple,
    accept: props.accept,
    "result-type": "file",
    "after-read": onAfterRead
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_1
      ])
    ]),
    _: 3
  }, 8, ["max-count", "disabled", "readonly", "multiple", "accept"]))
}
}

})